// 고객 화면 「앱으로 받기」 안내 — 한 번 닫거나 본 기록은 이 브라우저에만 · 앱 안이거나 저장소가 막히면 조용히 넘긴다.

import { isNativeApp } from "@/lib/native-bridge";
import { browserDraftStore, type DraftStore } from "@/modules/project/ui/log-draft";

// 「내 현장」 앱 안내 카드를 닫았다 · 첫 댓글 뒤 알림 시트를 봤다 — 둘은 따로 센다.
export const APP_PROMO_KEY = "buildpy:app-promo-dismissed";
export const APP_SHEET_KEY = "buildpy:app-sheet-seen";

type SeenStore = Pick<DraftStore, "getItem" | "setItem">;

export const wasSeen = (store: SeenStore | null, key: string): boolean => {
  if (!store) return true;
  try {
    return store.getItem(key) === "1";
  } catch {
    return true;
  }
};

export const markSeen = (store: SeenStore | null, key: string): void => {
  if (!store) return;
  try {
    store.setItem(key, "1");
  } catch {
    // 저장이 막히면 다음에도 한 번 더 보일 뿐이다.
  }
};

// 앱 안에서는 안내하지 않는다 · 저장소를 못 쓰면 매번 띄우지 않도록 본 셈 친다.
export const shouldInvite = (key: string, native: boolean = isNativeApp(), store: SeenStore | null = browserDraftStore()): boolean =>
  !native && !wasSeen(store, key);

export const browserSeenStore = (): SeenStore | null => browserDraftStore();
